function Tootsie() {
  const innerHtml = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">
  <html
  xmlns="http://www.w3.org/1999/xhtml"
  xmlns:v="urn:schemas-microsoft-com:vml"
  xmlns:o="urn:schemas-microsoft-com:office:office"
>
  <head>
    <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
    <meta http-equiv="X-UA-Compatible" content="IE=edge" />
    <meta name="format-detection" content="telephone=no" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>თიატრის მოსაწვევი 🎭</title>
    <style type="text/css" emogrify="no">
      #outlook a {
        padding: 0;
      }
      .ExternalClass {
        width: 100%;
      }
      .ExternalClass,
      .ExternalClass p,
      .ExternalClass span,
      .ExternalClass font,
      .ExternalClass td,
      .ExternalClass div {
        line-height: 100%;
      }
      table td {
        border-collapse: collapse;
        mso-line-height-rule: exactly;
      }
      .editable.image {
        font-size: 0 !important;
        line-height: 0 !important;
      }
      .nl2go_preheader {
        display: none !important;
        mso-hide: all !important;
        mso-line-height-rule: exactly;
        visibility: hidden !important;
        line-height: 0px !important;
        font-size: 0px !important;
      }
      body {
        width: 100% !important;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
        margin: 0;
        padding: 0;
      }
      img {
        outline: none;
        text-decoration: none;
        -ms-interpolation-mode: bicubic;
      }
      a img {
        border: none;
      }
      table {
        border-collapse: collapse;
        mso-table-lspace: 0pt;
        mso-table-rspace: 0pt;
      }
      th {
        font-weight: normal;
        text-align: left;
      }
      *[class="gmail-fix"] {
        display: none !important;
      }
    </style>
    <style type="text/css" emogrify="no">
      @media (max-width: 600px) {
        .gmx-killpill {
          content: " \\x03D1";
        }
      }
    </style>
    <style type="text/css" emogrify="no">
      @media (max-width: 600px) {
        .gmx-killpill {
          content: "\\x03D1";
        }
        .r0-o {
          border-style: solid !important;
          margin: 0 auto 0 auto !important;
          width: 320px !important;
        }
        .r1-i {
          background-color: #ffffff !important;
        }
        .r2-o {
          border-style: solid !important;
          margin: 0 auto 0 auto !important;
          width: 100% !important;
        }
        .r3-c {
          box-sizing: border-box !important;
          display: block !important;
          valign: top !important;
          width: 100% !important;
        }
        .r4-o {
          border-style: solid !important;
          width: 100% !important;
        }
        .r5-o {
          background-size: auto !important;
          border-style: solid !important;
          margin: 0 auto 0 auto !important;
          width: 100% !important;
        }
        .r6-i {
          padding-bottom: 0px !important;
          padding-top: 0px !important;
        }
        .r7-o {
          border-style: solid !important;
          margin: 0 auto 0 0 !important;
          width: 100% !important;
        }
        .r8-i {
          padding-left: 35px !important;
          padding-right: 35px !important;
          padding-top: 15px !important;
          text-align: left !important;
        }
        .r9-o {
          background-size: auto !important;
          border-style: solid !important;
          margin: 0 auto 0 0 !important;
          width: 100% !important;
        }
        .r10-i {
          background-color: #607284 !important;
          padding-bottom: 15px !important;
          padding-left: 35px !important;
          padding-right: 35px !important;
          padding-top: 15px !important;
          text-align: justify !important;
        }
        .r11-i {
          background-color: #607284 !important;
          padding-bottom: 15px !important;
          padding-left: 35px !important;
          padding-right: 35px !important;
          padding-top: 15px !important;
          text-align: left !important;
        }
        .r12-i {
          background-color: #607284 !important;
          padding-left: 35px !important;
          padding-right: 35px !important;
          padding-top: 15px !important;
          text-align: left !important;
        }
        .r13-i {
          background-color: #607284 !important;
          padding-bottom: 50px !important;
          padding-left: 35px !important;
          padding-right: 35px !important;
          padding-top: 25px !important;
          text-align: left !important;
        }
        .r14-i {
          padding-bottom: 0px !important;
          padding-top: 15px !important;
        }
        .r15-i {
          background-color: #425163 !important;
          padding-bottom: 0px !important;
          padding-left: 0px !important;
          padding-right: 0px !important;
          padding-top: 0px !important;
        }
        .r16-c {
          box-sizing: border-box !important;
          text-align: center !important;
          valign: top !important;
          width: 100% !important;
        }
        .r17-o {
          background-size: auto !important;
          border-style: solid !important;
          margin: 0 auto 0 auto !important;
          width: 30% !important;
        }
        .r18-i {
          padding-bottom: 15px !important;
          padding-top: 15px !important;
        }
        .r19-i {
          background-color: #425163 !important;
          padding-left: 0px !important;
          padding-right: 0px !important;
        }
        .r20-c {
          box-sizing: border-box !important;
          padding-bottom: 18px !important;
          padding-top: 18px !important;
          text-align: center !important;
          valign: top !important;
          width: 100% !important;
        }
        body {
          -webkit-text-size-adjust: none;
        }
        .nl2go-responsive-hide {
          display: none;
        }
        .nl2go-body-table {
          min-width: unset !important;
        }
        .mobshow {
          height: auto !important;
          overflow: visible !important;
          max-height: unset !important;
          visibility: visible !important;
          border: none !important;
        }
        .resp-table {
          display: inline-table !important;
        }
        .magic-resp {
          display: table-cell !important;
        }
      }
    </style>
    <style type="text/css">
      p,
      h1,
      h2,
      h3,
      h4,
      ol,
      ul,
      li {
        margin: 0;
      }
      a,
      a:link {
        color: #163164;
        text-decoration: underline;
      }
      .nl2go-default-textstyle {
        color: #3b3f44;
        font-family: arial, helvetica, sans-serif;
        font-size: 18px;
        line-height: 1.5;
        word-break: break-word;
      }
      .default-button {
        color: #ffffff;
        font-family: arial, helvetica, sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: bold;
        line-height: 1.15;
        text-decoration: none;
        word-break: break-word;
      }
      .default-heading1 {
        color: #1f2d3d;
        font-family: arial, helvetica, sans-serif;
        font-size: 36px;
        word-break: break-word;
      }
      .default-heading2 {
        color: #1f2d3d;
        font-family: arial, helvetica, sans-serif;
        font-size: 32px;
        word-break: break-word;
      }
      .default-heading3 {
        color: #1f2d3d;
        font-family: arial, helvetica, sans-serif;
        font-size: 24px;
        word-break: break-word;
      }
      .default-heading4 {
        color: #1f2d3d;
        font-family: arial, helvetica, sans-serif;
        font-size: 18px;
        word-break: break-word;
      }
      a[x-apple-data-detectors] {
        color: inherit !important;
        text-decoration: inherit !important;
        font-size: inherit !important;
        font-family: inherit !important;
        font-weight: inherit !important;
        line-height: inherit !important;
      }
      .no-show-for-you {
        border: none;
        display: none;
        float: none;
        font-size: 0;
        height: 0;
        line-height: 0;
        max-height: 0;
        mso-hide: all;
        overflow: hidden;
        table-layout: fixed;
        visibility: hidden;
        width: 0;
      }
    </style>
    <!--[if mso
      ]><xml>
        <o:OfficeDocumentSettings>
          <o:AllowPNG /> <o:PixelsPerInch>96</o:PixelsPerInch>
        </o:OfficeDocumentSettings>
      </xml><!
    [endif]-->
  </head>
  <body
    bgcolor="#ffffff"
    text="#3b3f44"
    link="#163164"
    yahoo="fix"
    style="background-color: #ffffff"
  >
    <table
      cellspacing="0"
      cellpadding="0"
      border="0"
      role="presentation"
      class="nl2go-body-table"
      width="100%"
      style="background-color: #ffffff; width: 100%"
    >
      <tr>
        <td>
          <table
            cellspacing="0"
            cellpadding="0"
            border="0"
            role="presentation"
            width="900"
            align="center"
            class="r0-o"
            style="table-layout: fixed; width: 900px"
          >
            <tr>
              <td valign="top" class="r1-i" style="background-color: #ffffff">
                <table
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  role="presentation"
                  width="100%"
                  align="center"
                  class="r2-o"
                  style="
                    background-color: #607284;
                    table-layout: fixed;
                    width: 100%;
                  "
                >
                  <tr>
                    <th
                      width="100%"
                      valign="top"
                      class="r3-c"
                      style="font-weight: normal"
                    >
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="900"
                        align="center"
                        class="r5-o"
                        style="table-layout: fixed; width: 900px"
                      >
                        <tr>
                          <td
                            class="r6-i"
                            style="font-size: 0px; line-height: 0px"
                          >
                            <img
                              src="https://img.mailinblue.com/6597977/images/content_library/original/66797ee14a41b169d3aa8719.jpeg"
                              width="900"
                              border="0"
                              style="display: block; width: 100%"
                            />
                          </td>
                        </tr>
                      </table>
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        align="left"
                        class="r7-o"
                        style="table-layout: fixed; width: 100%"
                      >
                        <tr>
                          <td
                            align="left"
                            valign="top"
                            class="r8-i nl2go-default-textstyle"
                            style="
                              color: #3b3f44;
                              font-family: arial, helvetica, sans-serif;
                              font-size: 18px;
                              line-height: 1.5;
                              word-break: break-word;
                              padding-left: 35px;
                              padding-right: 35px;
                              padding-top: 15px;
                              text-align: left;
                            "
                          >
                            <div>
                              <h2
                                class="default-heading2"
                                style="
                                  margin: 0;
                                  color: #1f2d3d;
                                  font-family: arial, helvetica, sans-serif;
                                  font-size: 32px;
                                  word-break: break-word;
                                "
                              >
                                <span style="color: #ffffff; font-size: 22px"
                                  ><strong>ძვირფასო პარტნიორებო,</strong></span
                                >
                              </h2>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        align="left"
                        class="r9-o"
                        style="
                          border-collapse: separate;
                          border-radius: 0px;
                          table-layout: fixed;
                          width: 100%;
                        "
                      >
                        <tr>
                          <td
                            align="justify"
                            valign="top"
                            class="r10-i nl2go-default-textstyle"
                            style="
                              color: #3b3f44;
                              font-family: arial, helvetica, sans-serif;
                              font-size: 18px;
                              line-height: 1.5;
                              word-break: break-word;
                              background-color: #607284;
                              border-radius: 0px;
                              padding-bottom: 15px;
                              padding-left: 35px;
                              padding-right: 35px;
                              padding-top: 15px;
                              text-align: justify;
                              word-wrap: break-word;
                            "
                          >
                            <div>
                              <p style="margin: 0">
                                <span style="color: #ffffff"
                                  >სადაზღვევო კომპანია "იმედი L" ტურისტულ
                                  ინდუსტრიაში სიახლეებით ბრუნდება. საზაფხულო
                                  ტურისტულ სეზონზე დავიწყეთ ახალი კონკურსი,
                                  რომელშიც ყველა პარტნიორი ჩაერთო.</span
                                >
                              </p>
                              <p style="margin: 0">
                                <br /><span style="color: #ffffff"
                                  >გიწვევთ თეატრი სახელოსნო 42-ში გამართულ
                                  ღონისძიებაზე, სადაც შედგება "ტუტსის"
                                  ექსკლუზიური ჩვენება. ღონისძიების დაწყებამდე,
                                  კომპანიის წარმომადგენელი მოგაწვდით ინფორმაციას
                                  კონკურსის მიმდინარეობისა და დეტალების შესახებ,
                                  ასევე გაგიზიარებთ „იმედი L"-ის სამომავლო
                                  გეგმებს. ამასთან, გამოვლინდებიან და
                                  დასაჩუქრდებიან კონკურსის მიმდინარე
                                  გამარჯვებულები.</span
                                ><br /><span style="color: #ffffff"
                                  >მოხარული ვიქნებით, თუ შემოგვიერთდებით.</span
                                >
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        align="left"
                        class="r9-o"
                        style="
                          border-collapse: separate;
                          border-radius: 0px;
                          table-layout: fixed;
                          width: 100%;
                        "
                      >
                        <tr>
                          <td
                            align="left"
                            valign="top"
                            class="r11-i nl2go-default-textstyle"
                            style="
                              color: #3b3f44;
                              font-family: arial, helvetica, sans-serif;
                              font-size: 18px;
                              line-height: 1.5;
                              word-break: break-word;
                              background-color: #607284;
                              border-radius: 0px;
                              padding-bottom: 15px;
                              padding-left: 35px;
                              padding-right: 35px;
                              padding-top: 15px;
                              text-align: left;
                              word-wrap: break-word;
                            "
                          >
                            <div>
                              <p style="margin: 0">
                                <span style="color: #ffffff"
                                  ><strong>ადაპტირებული ტექსტის ავტორი</strong>
                                  | ლევან წულაძე</span
                                >
                              </p>
                              <p style="margin: 0">
                                <span style="color: #ffffff"
                                  ><strong>რეჟისორი და სცენოგრაფი</strong> |
                                  ლევან წულაძე </span
                                ><br /><span style="color: #ffffff"
                                  ><strong>კოსტიუმების მხატვარი </strong>| ნინო
                                  სურგულაძე </span
                                ><br /><span style="color: #ffffff"
                                  ><strong>ქორეოგრაფი</strong> | თინათინ
                                  წულაძე </span
                                ><br /><span style="color: #ffffff"
                                  ><strong>მუსიკალური გამფორმებელი</strong> |
                                  ზურაბ გაგლოშვილი </span
                                ><br /><span style="color: #ffffff"
                                  ><strong>მხატვარ-გრიმიორი </strong>| გიგა
                                  ბაგრატიონ-გოგაძე </span
                                ><br /><span style="color: #ffffff"
                                  ><strong>ვიდეო ინსტალაცია </strong>| დათა
                                  დვალიშვილი </span
                                ><br /><span style="color: #ffffff"
                                  ><strong>ტექნიკური რეჟისორი</strong> | ნინო
                                  კალანდაძე</span
                                >
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        align="left"
                        class="r7-o"
                        style="table-layout: fixed; width: 100%"
                      >
                        <tr>
                          <td
                            align="left"
                            valign="top"
                            class="r12-i nl2go-default-textstyle"
                            style="
                              color: #3b3f44;
                              font-family: arial, helvetica, sans-serif;
                              font-size: 18px;
                              line-height: 1.5;
                              word-break: break-word;
                              background-color: #607284;
                              padding-left: 35px;
                              padding-right: 35px;
                              padding-top: 15px;
                              text-align: left;
                            "
                          >
                            <div>
                              <h2
                                class="default-heading2"
                                style="
                                  margin: 0;
                                  color: #1f2d3d;
                                  font-family: arial, helvetica, sans-serif;
                                  font-size: 32px;
                                  word-break: break-word;
                                "
                              >
                                <span style="color: #ffffff; font-size: 20px"
                                  >მონაწილეობენ</span
                                >
                              </h2>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        align="left"
                        class="r7-o"
                        style="table-layout: fixed; width: 100%"
                      >
                        <tr>
                          <td
                            align="left"
                            valign="top"
                            class="r11-i nl2go-default-textstyle"
                            style="
                              color: #3b3f44;
                              font-family: arial, helvetica, sans-serif;
                              font-size: 18px;
                              line-height: 1.5;
                              word-break: break-word;
                              background-color: #607284;
                              padding-bottom: 15px;
                              padding-left: 35px;
                              padding-right: 35px;
                              padding-top: 15px;
                              text-align: left;
                              word-wrap: break-word;
                            "
                          >
                            <div>
                              <p style="margin: 0">
                                <span style="color: #ffffff"
                                  >ნიკა კუჭავა, ანა ვასაძე, მანანა
                                  კოზაკოვა, </span
                                ><br /><span style="color: #ffffff"
                                  >თეონა ქოქრაშვილი, დუტა სხირტლაძე</span
                                ><br /><span style="color: #ffffff"
                                  >ჯეჯი სხირტლაძე, ონისე ონიანი, ანდრია
                                  გველესიანი, </span
                                ><br /><span style="color: #ffffff"
                                  >ნინო წულაძე, ანა გვანცელაძე, მარიამ
                                  ღვინიანიძე, </span
                                ><br /><span style="color: #ffffff"
                                  >ლუკა კალატოზიშვილი, ლაშა მორჩილაძე</span
                                >
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        align="left"
                        class="r7-o"
                        style="table-layout: fixed; width: 100%"
                      >
                        <tr>
                          <td
                            align="left"
                            valign="top"
                            class="r12-i nl2go-default-textstyle"
                            style="
                              color: #3b3f44;
                              font-family: arial, helvetica, sans-serif;
                              font-size: 18px;
                              line-height: 1.5;
                              word-break: break-word;
                              background-color: #607284;
                              padding-left: 35px;
                              padding-right: 35px;
                              padding-top: 15px;
                              text-align: left;
                            "
                          >
                            <div>
                              <h2
                                class="default-heading2"
                                style="
                                  margin: 0;
                                  color: #1f2d3d;
                                  font-family: arial, helvetica, sans-serif;
                                  font-size: 32px;
                                  word-break: break-word;
                                "
                              >
                                <span style="color: #ffffff; font-size: 20px"
                                  >სპექტაკლის შესახებ</span
                                >
                              </h2>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        align="left"
                        class="r7-o"
                        style="table-layout: fixed; width: 100%"
                      >
                        <tr>
                          <td
                            align="justify"
                            valign="top"
                            class="r10-i nl2go-default-textstyle"
                            style="
                              color: #3b3f44;
                              font-family: arial, helvetica, sans-serif;
                              font-size: 18px;
                              line-height: 1.5;
                              word-break: break-word;
                              background-color: #607284;
                              padding-bottom: 15px;
                              padding-left: 35px;
                              padding-right: 35px;
                              padding-top: 15px;
                              text-align: justify;
                              word-wrap: break-word;
                            "
                          >
                            <div>
                              <p style="margin: 0">
                                <span style="color: #ffffff"
                                  >სპექტაკლის იდეა ამავე სახელწოდების ფილმიდან
                                  მოდის, თუმცა მთავარი აქცენტი მსახიობის
                                  პროფესიისადმი სიყვარულზე და თავგანწირვაზეა. ეს
                                  არის ამბავი მსახიობის უამრავი ფიქრის,
                                  ტკივილის, გრძნობების და იმ მთავარი მისიის
                                  შესახებ, რომელიც საკუთარ თავს თავადვე
                                  განუსაზღვრა და ამ მისიის შესასრულებლად ყოველ
                                  დღე იბრძვის.</span
                                >
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        align="left"
                        class="r7-o"
                        style="table-layout: fixed; width: 100%"
                      >
                        <tr>
                          <td
                            align="left"
                            valign="top"
                            class="r13-i nl2go-default-textstyle"
                            style="
                              color: #3b3f44;
                              font-family: arial, helvetica, sans-serif;
                              font-size: 18px;
                              line-height: 1.5;
                              word-break: break-word;
                              background-color: #607284;
                              padding-bottom: 50px;
                              padding-left: 35px;
                              padding-right: 35px;
                              padding-top: 25px;
                              text-align: left;
                              word-wrap: break-word;
                            "
                          >
                            <div>
                              <p style="margin: 0">
                                <span style="color: #ffffff; font-size: 18px"
                                  ><strong>თარიღი </strong>- 29 ივნისი</span
                                >
                              </p>
                              <p style="margin: 0">
                                <span style="color: #ffffff; font-size: 18px"
                                  ><strong>ადგილი </strong>-  თეატრი სახელოსნო
                                  42, წერეთლის გამზირი 42</span
                                >
                              </p>
                              <p style="margin: 0">
                                <span style="color: #ffffff; font-size: 18px"
                                  ><strong>დრო -</strong> 19:30 </span
                                >
                              </p>
                              <p style="margin: 0">
                                <span style="color: #ffffff; font-size: 18px"
                                  ><strong>Dress code</strong> - საღამოს
                                  ჩაცმულობა</span
                                >
                              </p>
                              <p style="margin: 0"> </p>
                              <p style="margin: 0">
                                <span style="color: #ffffff; font-size: 22px"
                                  ><strong>გელით სპექტაკლზე!</strong></span
                                >
                              </p>
                            </div>
                          </td>
                        </tr>
                      </table>
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="900"
                        align="center"
                        class="r2-o"
                        style="table-layout: fixed; width: 900px"
                      >
                        <tr>
                          <td
                            class="r14-i"
                            style="
                              font-size: 0px;
                              line-height: 0px;
                              padding-top: 15px;
                            "
                          >
                            <img
                              src="https://img.mailinblue.com/6597977/images/content_library/original/66797e914a41b169d3aa86fd.png"
                              width="900"
                              border="0"
                              style="display: block; width: 100%"
                            />
                          </td>
                        </tr>
                      </table>
                    </th>
                  </tr>
                </table>
                <table
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  role="presentation"
                  width="100%"
                  align="center"
                  class="r2-o"
                  style="table-layout: fixed; width: 100%"
                >
                  <tr>
                    <th
                      width="50%"
                      valign="top"
                      class="r3-c"
                      style="background-color: #425163; font-weight: normal"
                    >
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        class="r4-o"
                        style="table-layout: fixed; width: 100%"
                      >
                        <tr>
                          <td
                            valign="top"
                            class="r15-i"
                            style="background-color: #425163"
                          >
                            <table
                              width="100%"
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              role="presentation"
                            >
                              <tr>
                                <td class="r16-c" align="center">
                                  <table
                                    cellspacing="0"
                                    cellpadding="0"
                                    border="0"
                                    role="presentation"
                                    width="135"
                                    class="r17-o"
                                    style="table-layout: fixed; width: 135px"
                                  >
                                    <tr>
                                      <td
                                        class="r18-i"
                                        style="
                                          font-size: 0px;
                                          line-height: 0px;
                                          padding-bottom: 15px;
                                          padding-top: 15px;
                                        "
                                      >
                                        <img
                                          src="https://img.mailinblue.com/6597977/images/content_library/original/667951884641a4b538d8abc9.png"
                                          width="135"
                                          border="0"
                                          style="display: block; width: 100%"
                                        />
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </th>
                    <th
                      width="50%"
                      valign="top"
                      class="r3-c"
                      style="background-color: #425163; font-weight: normal"
                    >
                      <table
                        cellspacing="0"
                        cellpadding="0"
                        border="0"
                        role="presentation"
                        width="100%"
                        class="r4-o"
                        style="table-layout: fixed; width: 100%"
                      >
                        <tr>
                          <td
                            valign="top"
                            class="r19-i"
                            style="background-color: #425163"
                          >
                            <table
                              width="100%"
                              cellspacing="0"
                              cellpadding="0"
                              border="0"
                              role="presentation"
                            >
                              <tr>
                                <td
                                  class="r20-c nl2go-default-textstyle"
                                  align="center"
                                  style="
                                    color: #3b3f44;
                                    font-family: arial, helvetica, sans-serif;
                                    font-size: 18px;
                                    word-break: break-word;
                                    line-height: 1;
                                    padding-bottom: 18px;
                                    padding-top: 18px;
                                    text-align: center;
                                    valign: top;
                                  "
                                >
                                  <div>
                                    <p style="margin: 0">
                                      <span
                                        style="color: #ffffff; font-size: 12px"
                                        >All rights reserved</span
                                      >
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </td>
                        </tr>
                      </table>
                    </th>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>
`;

  return (
    <>
      <div className="mt-5"></div>
      <div dangerouslySetInnerHTML={{ __html: innerHtml }}></div>
    </>
  );
}

export default Tootsie;
